import { render } from "./ManagePeopleUserAssignment.vue?vue&type=template&id=497f2690&lang=pug"
import script from "./ManagePeopleUserAssignment.vue?vue&type=script&lang=js"
export * from "./ManagePeopleUserAssignment.vue?vue&type=script&lang=js"

import "./ManagePeopleUserAssignment.vue?vue&type=style&index=0&id=497f2690&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__